import ReactDOM from 'react-dom/client';
import { App } from './App';
import { AuthContextProvider } from "./Providers/Auth";
import { ChakraProvider } from '@chakra-ui/react'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthContextProvider>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </AuthContextProvider>
);

